<span
  *ngIf="label"
  class="al-badge"
  [ngClass]="'al-badge--' + variant"
  [nbTooltip]="tooltip || ''"
  [nbTooltipDisabled]="!tooltip"
>
  {{ label }}
</span>
